import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner, faEnvelopeCircleCheck } from '@fortawesome/free-solid-svg-icons';
import { useAppContext } from '../../../context/AppContext';
import { postData } from '../../../services/postData';
import { markPendingUserCreated } from '../../../services';
import { OnboardingChoiceScreen } from './OnboardingChoiceScreen';
import logo from '../../../assets/images/logo.webp';
export const VerifyEmailPage = () => {
    const { token: verificationToken } = useParams();
    const navigate = useNavigate();
    const { base_url, setToken, refreshAppState } = useAppContext();
    const [status, setStatus] = useState('verifying');
    const [error, setError] = useState('');
    const [isContinuing, setIsContinuing] = useState(false);

    useEffect(() => {
        const verifyEmail = async () => {
            if (!verificationToken) {
                setStatus('error');
                setError('Invalid verification link.');
                return;
            }

            const verifiedKey = `verify-email-done-${verificationToken}`;
            if (sessionStorage.getItem(verifiedKey)) {
                setStatus('verified');
                return;
            }

            try {
                const response = await postData(null, `${base_url}/apis/admin/verify-email`, {
                    token: verificationToken
                });

                if (response?.token) {
                    setToken(response.token, true);
                    sessionStorage.setItem(verifiedKey, '1');
                    markPendingUserCreated();
                    setStatus('verified');
                    return;
                }

                if (response?.status >= 200 && response?.status < 300) {
                    sessionStorage.setItem(verifiedKey, '1');
                    setStatus('verified');
                    return;
                }

                setStatus('error');
                setError(response?.msg || 'Email verification failed. The link may be invalid or expired.');
            } catch (err) {
                setStatus('error');
                setError('Email verification failed. Please try again.');
                console.error('Email verification error:', err);
            }
        };

        verifyEmail();
    }, [verificationToken, base_url, setToken]);

    const handleExistingProject = async () => {
        setIsContinuing(true);
        try {
            await refreshAppState();
            navigate('/');
        } finally {
            setIsContinuing(false);
        }
    };

    if (status === 'verified') {
        return (
            <OnboardingChoiceScreen
                pageTitle="Email Verification"
                title="You're all set!"
                description="Your email has been verified and you've been added to your company. What would you like to do next?"
                icon={faEnvelopeCircleCheck}
                onNewProject={() => navigate('/new-project')}
                onExistingProject={handleExistingProject}
                isContinuing={isContinuing}
            />
        );
    }

    return (
        <div className="modal-overlay auth-page">
            <div className="auth-page__header">
                <img
                    src={logo}
                    alt="Company Logo"
                    className="auth-page__logo"
                />
                <h1 className="auth-page__title">
                    Email Verification
                </h1>
            </div>

            <div className="modal-content auth-page__card auth-page__card--md">
                {status === 'verifying' && (
                    <div className="auth-page__center auth-page__center--padded">
                        <FontAwesomeIcon icon={faSpinner} spin className="auth-page__spinner-icon" />
                        <p className="auth-page__description--flush">Verifying your email address...</p>
                    </div>
                )}

                {status === 'error' && (
                    <div className="auth-page__center">
                        <h2 className="modal-title modal-title--compact">Verification Failed</h2>
                        <p className="auth-page__error-text">{error}</p>
                        <button
                            type="button"
                            className="btn btn-primary btn--block"
                            onClick={() => navigate('/login')}
                        >
                            Go to Login
                        </button>
                    </div>
                )}
            </div>
        </div>
    );
};
